export default {"generalLinksWrapper":"pQjkX","generalLinksNavContainer":"VRn7G","generalLinksNavItem":"P69Jd yl3hn ewayX"};